@if ((unreadNews() ?? 0) > 0) {
  <div class="position-relative">
    <apm-icon
      size="md"
      [isButton]="true"
      [matTooltip]="('444447' | apmTranslate) ?? ''"
      (click)="onBadgeClickHandler()"
      icon="i_signal"
    ></apm-icon>
    <div class="badge-counter">
      <span class="outer-circle">
        <span class="inner-circle">{{ unreadNews() }}</span>
      </span>
    </div>
  </div>
}
